import { render, staticRenderFns } from "./device-edit.vue?vue&type=template&id=b4a77dca&scoped=true&"
import script from "./device-edit.vue?vue&type=script&lang=js&"
export * from "./device-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a77dca",
  null
  
)

export default component.exports